import React, { useState } from "react";
import "./TourSlider.css"; // Thêm CSS tùy chỉnh nếu cần
const FAQ = () => {
  const [faqShow, setFaqShow] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });

  const toggleFaq = (index) => {
    setFaqShow((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="bg-light-200 card-bg-light mb-4">
      <h5 className="fs-18 mb-3">Những câu hỏi thường gặp</h5>
      <div className="accordion faq-accordion" id="accordionFaq">
        <div className="accordion-item show mb-2">
          <div className="accordion-header">
            <button
              className={`accordion-button fw-medium ${
                faqShow[1] ? "" : "collapsed"
              }`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-collapseOne"
              aria-expanded="false"
              aria-controls="faq-collapseOne"
              onClick={() => toggleFaq(1)}
            >
              Có cung cấp dịch vụ hủy miễn phí để được hoàn lại toàn bộ tiền
              không?
            </button>
          </div>
          <div
            id="faq-collapseOne"
            className={`accordion-collapse ${!faqShow[1] && "collapse"} `}
            data-bs-parent="#accordionFaq"
          >
            <div className="accordion-body">
              <p className="mb-0">
                Có giá phòng hoàn lại toàn bộ có sẵn để đặt trên trang web của
                chúng tôi. Nếu bạn đã đặt phòng với giá phòng hoàn lại toàn bộ,
                bạn có thể hủy phòng này trước vài ngày so với ngày nhận phòng
                tùy thuộc vào chính sách hủy phòng của cơ sở lưu trú. Chỉ cần
                đảm bảo kiểm tra chính sách hủy phòng của cơ sở lưu trú này để
                biết các điều khoản và điều kiện chính xác.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item mb-2">
          <div className="accordion-header">
            <button
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-two"
              aria-expanded="false"
              aria-controls="faq-two"
              className={`accordion-button fw-medium ${
                faqShow[2] ? "" : "collapsed"
              }`}
              onClick={() => toggleFaq(2)}
            >
              Có hồ bơi không?
            </button>
          </div>
          <div
            id="faq-two"
            data-bs-parent="#accordionFaq"
            className={`accordion-collapse ${!faqShow[2] && "collapse"} `}
          >
            <div className="accordion-body">
              <p className="mb-0">
                Có giá phòng hoàn lại toàn bộ có sẵn để đặt trên trang web của
                chúng tôi. Nếu bạn đã đặt phòng với giá phòng hoàn lại toàn bộ,
                bạn có thể hủy phòng này trước vài ngày so với ngày nhận phòng
                tùy thuộc vào chính sách hủy phòng của cơ sở lưu trú. Chỉ cần
                đảm bảo kiểm tra chính sách hủy phòng của cơ sở lưu trú này để
                biết các điều khoản và điều kiện chính xác.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item mb-2">
          <div className="accordion-header">
            <button
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-three"
              aria-expanded="false"
              aria-controls="faq-three"
              className={`accordion-button fw-medium ${
                faqShow[3] ? "" : "collapsed"
              }`}
              onClick={() => toggleFaq(3)}
            >
              Có được phép mang theo vật nuôi không?
            </button>
          </div>
          <div
            id="faq-three"
            data-bs-parent="#accordionFaq"
            className={`accordion-collapse ${!faqShow[3] && "collapse"} `}
          >
            <div className="accordion-body">
              <p className="mb-0">
                Có giá phòng hoàn lại toàn bộ có sẵn để đặt trên trang web của
                chúng tôi. Nếu bạn đã đặt phòng với giá phòng hoàn lại toàn bộ,
                bạn có thể hủy phòng này trước vài ngày so với ngày nhận phòng
                tùy thuộc vào chính sách hủy phòng của cơ sở lưu trú. Chỉ cần
                đảm bảo kiểm tra chính sách hủy phòng của cơ sở lưu trú này để
                biết các điều khoản và điều kiện chính xác.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item mb-2">
          <div className="accordion-header">
            <button
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-four"
              aria-expanded="false"
              aria-controls="faq-four"
              className={`accordion-button fw-medium ${
                faqShow[4] ? "" : "collapsed"
              }`}
              onClick={() => toggleFaq(4)}
            >
              Có dịch vụ đưa đón sân bay không?
            </button>
          </div>
          <div
            id="faq-four"
            data-bs-parent="#accordionFaq"
            className={`accordion-collapse ${!faqShow[4] && "collapse"} `}
          >
            <div className="accordion-body">
              <p className="mb-0">
                Có giá phòng hoàn lại toàn bộ có sẵn để đặt trên trang web của
                chúng tôi. Nếu bạn đã đặt phòng với giá phòng hoàn lại toàn bộ,
                bạn có thể hủy phòng này trước vài ngày so với ngày nhận phòng
                tùy thuộc vào chính sách hủy phòng của cơ sở lưu trú. Chỉ cần
                đảm bảo kiểm tra chính sách hủy phòng của cơ sở lưu trú này để
                biết các điều khoản và điều kiện chính xác.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item mb-2">
          <div className="accordion-header">
            <button
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-five"
              aria-expanded="false"
              aria-controls="faq-five"
              className={`accordion-button fw-medium ${
                faqShow[5] ? "" : "collapsed"
              }`}
              onClick={() => toggleFaq(5)}
            >
              Giờ nhận phòng và trả phòng là mấy giờ?
            </button>
          </div>
          <div
            id="faq-five"
            data-bs-parent="#accordionFaq"
            className={`accordion-collapse ${!faqShow[5] && "collapse"} `}
          >
            <div className="accordion-body">
              <p className="mb-0">
                Có giá phòng hoàn lại toàn bộ có sẵn để đặt trên trang web của
                chúng tôi. Nếu bạn đã đặt phòng với giá phòng hoàn lại toàn bộ,
                bạn có thể hủy phòng này trước vài ngày so với ngày nhận phòng
                tùy thuộc vào chính sách hủy phòng của cơ sở lưu trú. Chỉ cần
                đảm bảo kiểm tra chính sách hủy phòng của cơ sở lưu trú này để
                biết các điều khoản và điều kiện chính xác.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
